import type { ImageSourcePropType } from 'react-native';

import { VideoPreparation } from './VideoPreparation';

export type GoogleElsVideoPreparationProps = {
  title: string;
  shareLabel: string;
  speakerLabel: string;
  shareImage: ImageSourcePropType;
  speakerImage: ImageSourcePropType;
  inverse?: boolean;
};

export function GoogleElsVideoPreparation({ title, shareLabel, speakerLabel, shareImage, speakerImage, inverse = false }: GoogleElsVideoPreparationProps) {
  return (
    <VideoPreparation
      title={title}
      testID="incident-video-google-els-preparation-panel"
      inverse={inverse}
      actions={[{ label: shareLabel, image: shareImage }, { label: speakerLabel, image: speakerImage }]}
    />
  );
}
